<template>
    <div style="background: #fff;font-size:14px">
            <div style="display: flex; padding: 10px ; flex-direction: column">
              <div style="font-size: 13px; ">{{ item.remark}}</div>
              <div
                v-if="item.audioList && item.audioList.length > 0"
                style=" width: 100%; padding-top: 10px"
              >
                <div style="margin-top: 4px">语音</div>
                    <audio-player
                      ref="audioPlayer"
                      :audio-list="item.audioList"
                      :isLoop="false"
                      theme-color="#3f8ffb"
                    />           
              </div>
         
            <div v-if="item.imgList && item.imgList.length > 0" style="padding: 10px 0">
              <span>图片</span>
              <div style="display: flex; margin-top: 10px; flex-wrap: wrap">
                 <img
                v-for="(img, index) in item.imgList"
                :key="index"
                :src="img"
                style="width: 90px; height: 90px; border-radius: 3px; margin-right: 10px"
                @click="previewImage(item.imgList, index)"
              />
              </div>
            </div>
            <div
              v-if="item.videoList && item.videoList.length > 0"
              style="padding: 10px 0; border-top: 1px solid #ddd"
            >
              <span>短视频</span>
                <div v-for="(video, index) in item.videoList" :key="index" class="uni-uploader__video" style="display: flex; margin-top: 10px; flex-wrap: wrap">
                  <div
                    style="
                      width: 90px;
                      height: 90px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      background: #000000;
                      margin-right: 10px;
                      margin-bottom: 10px;
                    "
                    @click="playVideo(video)"
                  >
                    <van-icon name="play-circle" color="#FFF"  class="video-play" size="40"/>
                  </div>
                </div>
            </div>
             <div class="desc-p" >
               {{item.address||'--'}}
            </div>
            <div class="desc-p" >
             <van-icon name="clock-o" style="margin-right: 2px"></van-icon> {{ item.createTime }}
            </div>
            <div class="bljd" >办理进度</div>
           </div>
        <!-- 办理进度 -->
        
      <div :class="{ active1: item.delFlag == 'N' }">
        <div class="m-timeline-area" >
          <div class="m-timeline">
            <div
              :class="['m-timeline-item', {'last': i === lcList.length - 1}]"
              v-for="(lc, i) in lcList"
              :key="i">
                <div class="u-tail"></div>
               <div class="u-dot"></div>
                <div class="u-title">{{lc.updateDate}}</div>
                <div class="u-content"  >处理人：{{ lc.updateUser_dictText || '--' }}</div>
               <div class="u-content" >处理方式：{{lc.flowAction_dictText}}</div>
                <div class="u-content">处理内容：{{ lc.comments || '--' }}</div>
               
              
           
              <div
                v-if="lc.audioList && lc.audioList.length > 0"
                style="width: 100%; margin-top: 10px;padding-left:30px"
              >
                <div style="margin-top: 4px">语音</div>
                  <audio-player
                      ref="audioPlayer"
                      :audio-list="item.audioList"
                      :isLoop="false"
                      theme-color="#3f8ffb"
                    /> 
              </div>
            <div v-if="lc.imgList && lc.imgList.length > 0" style="padding: 10px 30px">
              <span>图片</span>
              <div style="display: flex; margin-top: 10px; flex-wrap: wrap">
                 <img
                  v-for="(img, index) in lc.imgList"
                  :key="index"
                  :src="img"
                  style="width: 75px; height: 75px; border-radius: 3px; margin-right: 10px"
                  @click="previewImage(lc.imgList, index)"
                />
              </div>
            </div>
            <div v-if="lc.videoList && lc.videoList.length > 0" style="padding: 10px 30px">
              <div>
                <span>短视频</span>
                  <div v-for="(video, index) in lc.videoList" :key="index" class="uni-uploader__video" style="display: flex; margin-top: 10px; flex-wrap: wrap">
                    <div
                      style="
                        width: 140px;
                        height: 140px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        background: #000000;
                        margin-right: 10px;
                        margin-bottom: 10px;
                      "
                      @click="playVideo(video)"
                    >
                      <van-icon name="play-circle" color="#FFF"  class="video-play" size="40"/>
                    </div>
                  </div>
              </div>
            </div>


             <div v-if="lc.blgcList&&lc.blgcList.length>0" class="blgc-card">
                    <div class="blgc-title">
                      办理过程
                    </div>
                    <div class="blgc-c" v-for="(itm,index) in lc.blgcList" :key="index">
                      <div class="blgc-item"><span class="label">时间：</span><span class="value">{{itm.createTime}}</span></div>
                      <div class="blgc-item"><span class="label">内容：</span><span class="value">{{itm.nr}}</span></div>
                      <div class="blgc-item">
                        <span class="label">图片：</span>
                        <div class="value">
                          <div v-if="itm.tp" style="display: flex; margin-top: 10px; flex-wrap: wrap">
                              <img
                                v-for="(img, i) in itm.tp.split(',')"
                                :key="i"
                                :src="img"
                                style="width: 75px; height: 75px; border-radius: 3px; margin-right: 10px"
                                @click="previewImage(itm.tp.split(','), i)"
                              />
                            </div>
                          <span v-else>暂无图片</span>
                        </div>
                      </div>
                      <div class="blgc-item"><span class="label">附件：</span>
                        <div v-if="itm.fj" class="value">
                          <div v-for="(file,i) in  itm.fj.split(',')" :key="'file'+i" class="u-file" @click="openF(file)">
                            <image class="file-img" :src="`/static/files-icon/${fileExtIcon(file)}.png`" mode="widthFix"></image>
                            <span class="file-text">{{ getFileName(file) }}</span>
                          </div>
                        </div>
                         <span v-else>暂无附件</span>
                      </div>
                    </div>
                </div>

                <div class="u-content" v-if="lc.flowAction!='bj' && lc.flowAction!='zb_mdtj'" >下一步处理人：{{lc.currUser_dictText}}</div>

          </div>
          </div>
        </div>
      </div>
      <!-- <template v-if="item.flowId">
        <div class="sq" @click="zk()" v-if="item.delFlag == 'N'">展开<img src="@images/icon/down.png" /></div>
        <div class="sq" @click="sq()" v-else>收起<img src="@images/icon/up.png" /></div>
      </template> -->
    </div>
</template>

<script>
import { ImagePreview } from 'vant'
import { getAction, postAction } from '@/api/manage'
import AudioPlayer from '@liripeng/vue-audio-player'
export default {
  components: {
    AudioPlayer
  },
  props: {
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    type: {
      type: String,
      default: 'db',
    },
  },
  data() {
    return {
      lcList: [],
    }
  },
  created(){
    this.initData();
  },
  methods: {
    initData() {
      if(!this.item.flowId){
         return;
      }
      this.item.delFlag = 'Y'
      // this.isactive = !this.isactive
      var params = {
        flowId: this.item.flowId,
        currUser:this.item.currUser,
      }
       getAction('/zhshj/wghgridwork/query/by/flowdate/List', params).then((res) => {
        if (res.success) {
          this.lcList = this.convert(res.result)
        }
      })
    },
    sq() {
      this.item.delFlag = 'N'
    },
    previewImage(imageList, current) {
       ImagePreview({
        images: imageList,
        startPosition: current,
      })
    },
    getSjdjType(type) {
      var sjdjType =
        type == '03' ? 'primary' : type == '04' ? 'success' : type == '01' ? 'error' : type == '02' ? 'warning' : 'info'
      return sjdjType
    },
    playVideo(path) {
      var obj = { url: path }
      this.$router.push({
        path: '/common/video-play',
        query: obj,
      })
    },
    matchType(fileName) {
      // 后缀获取
      var suffix = ''
      // 获取类型结果
      var result = ''
      try {
        var flieArr = fileName.split('.')
        suffix = flieArr[flieArr.length - 1]
      } catch (err) {
        suffix = ''
      }
      // fileName无后缀返回 false
      if (!suffix) {
        result = false
        return result
      }
      // 图片格式
      var imglist = ['png', 'jpg', 'jpeg', 'bmp', 'gif']
      // 进行图片匹配
      result = imglist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'image'
        return result
      }
      // 匹配 视频
      var videolist = ['mp4', 'm2v', 'mkv', 'amr']
      result = videolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'video'
        return result
      }
      // 匹配 音频
      var radiolist = ['mp3', 'wav', 'wmv']
      result = radiolist.some(function (item) {
        return item == suffix
      })
      if (result) {
        result = 'radio'
        return result
      }
      // 其他 文件类型
      result = 'other'
      return result
    },
    convert(list) {
      var newList = list.map((val) => {
        var imgList = []
        var videoList = []
        var audioList = []
        if (val.commentFiles) {
          let arr = val.commentFiles.split(',')
          for (var i = 0; i < arr.length; i++) {
            var item = arr[i]
            if (this.matchType(item) == 'image') {
              imgList.push(item)
            } else if (this.matchType(item) == 'video') {
              videoList.push(item)
            } else if (this.matchType(item) == 'radio') {
              audioList.push(item)
            }
          }
        }
        val.imgList = imgList
        val.videoList = videoList
        val.audioList = audioList

        return val
      })
      return newList
    },
    clickCl() {
      // ,eventType:item.eventType,workType:item.workType,sjly:item.sjly
      var params = { id: this.item.flowId }
       this.$router.push({
        path: '/dbsj/db-cl',
        query:params,
      })
    },
     fileExtIcon(path) {
        let extName = path.substr((~-path.lastIndexOf('.') >>> 0) + 2); //处理文件扩展名
        switch (extName) {
          case 'doc':
          case 'docx':
          case 'rtf':
            return 'word';
            break;
          case 'ppt':
          case 'pptx':
            return 'ppt';
            break;
          case 'xls':
          case 'xlsx':
            return 'excel';
            break;
          case 'png':
          case 'jpg':
          case 'jpeg':
            return 'img';
            break;
          case 'mp3':
          case 'm4a':
          case 'aac':
          case 'wav':
            return 'audio';
            break;
          case 'gif':
            return 'gif';
            break;
          case 'pdf':
            return 'pdf';
            break;
          case 'txt':
            return 'txt';
            break;
          case 'rar':
          case 'zip':
            return 'zip';
            break;
          case 'avi':
          case 'mp4':
            return 'video';
            break;
          default:
            return 'unfolder';
        }
      },
      getFileName(url) {
        let name = url.substring(url.lastIndexOf('/') + 1, url.length);
        return name;
      },
      openF(filePath) {
        let fileExt = this.fileExtIcon(filePath);
        if ('img' == fileExt) {
          let imgList = [filePath];
          this.previewImage(imgList,0);
        } else {
          this.openFile(filePath)
        }
      },
      openFile(filePath) {
       window.location.href = filePath
      }
  },
}
</script>

<style lang="less" scoped>

.active1 {
  display: none !important;
}
.sq {
  border-top: 1px solid #ddd;
  text-align: center;
  padding: 8px 0;
  line-height: 20px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.sq img {
  width: 16px;
  margin-left: 10px;
  display: inline-block;
}

.desc-p{
  color: #999999; font-size: 13px; margin-top: 8px; display: flex; align-items: center
}

.bljd{
  font-size: 14px; 
  font-weight: bold;
  margin-top:10px;
}

@blue: #1890ff;
@green: #52c41a;
@red: #f5222d;
@gray: rgba(0,0,0,.25);
.m-timeline-area {
  margin: 0 auto;
  padding: 12px;
  .m-timeline {
    .m-timeline-item {
      position: relative;
      padding-bottom: 20px;
      .u-tail {
        position: absolute;
        top: 10px;
        left: 5px;
        height: calc(100% - 10px);
        border-left: 2px solid #e8e8e8; // 实线
        // border-left: 2px dotted #e8e8e8; // 点线
        // border-left: 2px dashed #e8e8e8; // 虚线
      }
      .u-dot {
        position: absolute;
        width: 8px;
        height: 8px;
        border: 2px solid @blue;
        border-radius: 50%;
      }
      .u-content {
        position: relative;
        top: -6px;
        margin-left: 30px;
        word-break: break-all;
        word-wrap: break-word;
        line-height: 24px;
        font-size: 14px;
        color: #313131;
      }
      .u-createTime{
        color: #696969;
        font-size: 13px;
        margin-left: 30px;
      }

      .u-title{
        font-size: 16px;
        color: #000;
        position: relative;
        top: -6px;
        margin-left: 30px;
        margin-bottom: 10px;
      }
    }
    .last {
      .u-tail {
        display: none;
      }
    }
  }
}


.blgc-card{
    border: 1px solid #dedede;
    border-radius: 2px;
    padding:12px 12px 0 12px;
    margin-right:14px;
    margin-left: 30px;
    margin-bottom: 10px;
    
    .blgc-title{
      font-weight: 600;
      color: #333;
      font-size: 14px;
    }
    .blgc-c{
      
      padding-bottom: 10px;
      margin-top:10px;
      .blgc-item {
        display: flex;
        text-indent: 0em;
      
        .label {
          color: #696969;
          margin-bottom: 10rpx;
        }
        .value {
          color: #333;
          flex: 1;
        }
      }
      &:not(:last-child){
        border-bottom:1px solid #dedede;
      }
    }
  }
  
  .u-file {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
  
    .file-img {
      width: 40rpx;
    }
  
    .file-text {
      flex: 1;
      margin-left: 10rpx;
      color: #1D6DDB;
      font-size: 14px;
    }
  }
</style>
